<script>
import { defineComponent } from "vue";
import { max } from "d3";

export default defineComponent({
  props: {
    yAccessor: {
      type: Function,
      default: () => {},
    },
    yScale: {
      type: Function,
      default: () => {},
    },
    series: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "#ececec",
    },
    legend: {
      type: String,
      default: "Points",
    },
  },
  setup(props) {
    const position = (d) => props.yScale(max(d, props.yAccessor));

    return {
      position,
    };
  },
});
</script>

<template>
  <foreignObject
    v-if="width > 0"
    :width="width"
    :height="height"
    style="overflow: inherit;"
    x="0"
    y="0"
  >
    <div style="display: flex;">
      <div
        v-for="({ user, score, highlighted, history }, i) of series"
        :key="i"
        class="absolute inlie-flex flex-col items-center"
        :style="{
          right: highlighted ? '45px' : '25px',
          top: `${position(history) - (highlighted ? 30 : 18)}px`,
        }"
      >
        <div
          class="
            rounded-full
            bg-cover bg-center bg-white
            border-4
            shadow-lg
          "
          :style="{
            width: `${highlighted ? 3.5 : 2.1875}rem`,
            height: `${highlighted ? 3.5 : 2.1875}rem`,
            borderColor: color,
            backgroundImage: `url(${user.avatar_url}), url('https://mainenerve.com/img/user-profile-images/user-avatar-square-anon.svg')`,
          }"
        />
        <div
          v-if="highlighted"
          :style="{ backgroundColor: color }"
          class="
            flex flex-col
            items-center
            px-2
            py-1
            leading-none
            text-white
            rounded-md
            shadow-lg
            transition
            duration-300
            ease-in-out
          "
        >
          <small>{{ score }}</small>
          <small>{{ legend }}</small>
        </div>
      </div>
    </div>
  </foreignObject>
</template>
